import { FR_PAGE } from 'scenes/FinancialResults/constants';
import { IO_PAGE } from 'scenes/IO/constants';
import { REGS_STATS_PAGE } from 'scenes/RegsStats/constants';
import {
  TRACKER_PAGE,
  TRACKER_COHORT_PAGE,
  TRACKER_CHART_PAGE,
} from 'scenes/Trackers/constants';

export const PAGES = {
  [TRACKER_PAGE]: 'Tracker',
  [TRACKER_COHORT_PAGE]: 'Tracker Cohorts',
  [TRACKER_CHART_PAGE]: 'Tracker Chart',
  [FR_PAGE]: 'Financial Results',
  [IO_PAGE]: 'IO management',
  [REGS_STATS_PAGE]: 'Regs Stats',
};

export const SCHEDULE = {
  1: 'Once',
  2: 'Daily',
  3: 'Weekly',
  4: 'Monthly',
};

export const NAME = 'name';
export const RECIPIENTS = 'recipients';
export const OWNER = 'owner';

export const DEFAULT_PAY_TO = 0;
export const DEFAULT_PERIOD = 2;
